import { Outlet } from 'react-router-dom'
import './styles.scss'

export const System = () => {
  return <Outlet />
}
